import type { UpdateMask } from "@/types/api";
import { FieldMaskSchema } from "@bufbuild/protobuf/wkt";
import { create } from "@bufbuild/protobuf";

export function normalizeUpdateMask(updateMask?: UpdateMask | string): UpdateMask | undefined {
  if (!updateMask) {
    return undefined;
  }

  // If it's a string like "field1,field2", convert to FieldMask
  if (typeof updateMask === "string") {
    return create(FieldMaskSchema, { paths: updateMask.split(",") });
  }

  // If it's already a FieldMask object, return as is
  if (typeof updateMask === "object" && !Array.isArray(updateMask)) {
    return updateMask as UpdateMask;
  }

  return undefined;
}

